import { useEffect } from 'react';
import { Form } from 'antd';
import { dirtySections } from './profileFormDiff';

/**
 * Reports the tiles with unsaved changes whenever the form store changes,
 * including setFieldsValue (repeat lists, reset).
 *
 * @param {Object} params
 * @param {import('antd').FormInstance} params.form
 * @param {{current: Object|null}} params.baselineRef - values as loaded
 * @param {boolean} params.enabled
 * @param {(name: string[]) => string} params.sectionOfField
 * @param {(ids: string[]) => void} [params.onChange]
 * @param {string[]} [params.extraSections] - tiles dirty for reasons outside
 *   the form store (e.g. files picked for upload)
 */
export default function useDirtySections({
  form,
  baselineRef,
  enabled,
  sectionOfField,
  onChange,
  extraSections = [],
}) {
  const watchedValues = Form.useWatch((values) => values, {
    form,
    preserve: true,
  });

  const extraKey = extraSections.join();

  useEffect(() => {
    if (!enabled || !onChange || !baselineRef.current) return;
    const fromForm = dirtySections(
      form.getFieldsValue(true),
      baselineRef.current,
      sectionOfField
    );
    const extra = extraKey ? extraKey.split(',') : [];
    onChange([...new Set([...fromForm, ...extra])].sort());
  }, [
    watchedValues,
    enabled,
    onChange,
    form,
    baselineRef,
    sectionOfField,
    extraKey,
  ]);
}
